import React from "react";

export interface ExportItem {
  id: string;
  url: string;
  createdAt: string;
  width: number;
  height: number;
  fps: number;
  sizeBytes: number;
}

/**
 * Every kept export, folded away at the foot of the Download tab: the newest
 * is the one the preview plays, so this is for going back to an older one,
 * which is rarely wanted and needs no room until it is.
 */
export const ExportHistory: React.FC<{ exports: readonly ExportItem[]; kept: number }> = ({ exports, kept }) => {
  if (exports.length < 2) return null;
  return (
    <details className="group border-t border-[var(--edge)] pt-3">
      <summary className="cursor-pointer rounded-[6px] text-[13px] font-semibold text-ink-200 focus-visible:outline-2 focus-visible:outline-[var(--edge-focus)]">{`Earlier exports (${exports.length})`}</summary>
      <p className="mt-1 text-[11.5px] text-ink-300">{`The last ${kept} are kept.`}</p>
      <ul className="mt-2 flex flex-col">
        {exports.map((item, index) => (
          <li key={item.id} className="flex items-center gap-3 border-t border-[var(--edge)] py-2 first:border-t-0">
            <div className="min-w-0 flex-1">
              <p className="text-[13px] text-ink-100">
                {new Date(item.createdAt).toLocaleString()}
                {index === 0 ? <span className="ml-2 text-[11px] text-signal-ok">latest</span> : null}
              </p>
              <p className="tnum mt-0.5 text-[11px] text-ink-300">
                {item.width}×{item.height} · {item.fps}fps · {(item.sizeBytes / (1024 * 1024)).toFixed(1)} MB
              </p>
            </div>
            <a className="shrink-0 text-[13px] font-semibold text-ember-600 hover:underline" href={item.url} download>
              Download
            </a>
          </li>
        ))}
      </ul>
    </details>
  );
};
